// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c4a583d3","355":"f339d3cb","453":"e9163cb0","667":"b99e1280","977":"4474ba5c"}[chunkId] + ".chunk.js";
};